/**
 * Image component - изображение для секций
 * Работает в React и в статике
 */

// Пресеты для соотношения сторон
const aspectClasses = {
  auto: '',
  square: 'aspect-square',
  video: 'aspect-video',
  '4/3': 'aspect-[4/3]',
  '3/2': 'aspect-[3/2]',
  '16/9': 'aspect-[16/9]',
  '21/9': 'aspect-[21/9]',
};

// Пресеты для object-fit
const fitClasses = {
  cover: 'object-cover',
  contain: 'object-contain',
  fill: 'object-fill',
  none: 'object-none',
};

// Пресеты для скругления
const roundedClasses = {
  none: 'rounded-none',
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  '2xl': 'rounded-2xl',
  full: 'rounded-full',
};

export default function Image({
  src,
  alt = '',
  aspect,            // auto, square, video, 4/3, 3/2, 16/9, 21/9
  fit = 'cover',     // cover, contain, fill, none
  rounded,           // none, sm, md, lg, xl, 2xl, full
  loading = 'lazy',  // lazy, eager
  className = '',
  style,
  fallback = '/assets/images/no_image.png',
  ...props
}) {
  // Собираем классы
  const classes = [
    aspect ? aspectClasses[aspect] || '' : '',
    fitClasses[fit] || fitClasses.cover,
    rounded ? roundedClasses[rounded] || '' : '',
    className,
  ].filter(Boolean).join(' ');

  const handleError = (e) => {
    if (fallback && e.target.src !== fallback) {
      e.target.src = fallback;
    }
  };

  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      className={classes}
      style={style}
      onError={handleError}
      {...props}
    />
  );
}

// Экспорт пресетов для использования в настройках
Image.aspects = Object.keys(aspectClasses);
Image.fits = Object.keys(fitClasses);
Image.roundedOptions = Object.keys(roundedClasses);
